module.exports = __webpack_public_path__ + "img/sv106.07e370e0.svg";